import React from 'react';
import styled from 'styled-components';
import Cell from './Cell';
import { COLORS, CELL_SIZE } from '../utils/constants';

const StyledNextTetromino = styled.div`
  display: grid;
  grid-template-rows: repeat(${props => props.height}, ${CELL_SIZE}px);
  grid-template-columns: repeat(${props => props.width}, ${CELL_SIZE}px);
  grid-gap: 0;
  border: 2px solid #333;
  background: #111;
  margin-top: 20px;
  padding: 10px;
`;

const NextTetromino = ({ shape, colorIndex }) => {
  const height = shape.length;
  const width = shape[0].length;

  // 创建预览展示数组
  const previewBoard = Array(height)
    .fill()
    .map(() => Array(width).fill(0));

  // 填充预览展示
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      if (shape[y][x] !== 0) {
        previewBoard[y][x] = colorIndex + 1;
      }
    }
  }

  return (
    <StyledNextTetromino height={height} width={width}>
      {previewBoard.map((row, y) =>
        row.map((cell, x) => (
          <Cell key={`preview-${y}-${x}`} type={cell} colors={COLORS} />
        ))
      )}
    </StyledNextTetromino>
  );
};

export default NextTetromino;